/* eslint-disable */
export default {
  rateExceeded:
    'Das Anforderungslimit wurde überschritten. Die App wird in {ttl} Sekunden fortgesetzt.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
